import "./Basket.scss";
import {useEffect, useRef, useState} from "react";
import {useUserStore} from "../../../../../modules/shop/user/store";
import {Purchase} from "./interfaces";
import NoItems from "./components/NoItems/NoItems";
import {getPurchases} from "./components/requests";
import ActivatedServices from "./components/ActivatedServices/ActivatedServices";
import BasketItems from "./components/BasketItems/BasketItems";

// Кошик: як забрати товар, товари до видачі, активні послуги (пріоритет, сет)
const Basket = () => {
    const [purchasesServices, setPurchasesServices] = useState<Purchase[]>([])
    const [purchasesProducts, setPurchasesProducts] = useState<Purchase[]>([])
    // поки перший запит не завершився, показуємо скелетон, а не «Кошик порожній»
    const [loaded, setLoaded] = useState(false)

    const fetchPurchases = () => getPurchases(setPurchasesServices, setPurchasesProducts)

    useEffect(() => {
        fetchPurchases().finally(() => setLoaded(true))
    }, [])

    // Поки є повернення «в обробці» (наприклад, після оновлення сторінки), раз на 5 секунд оновлюємо список,
    // щоб годинник зник, коли повернення виконається або скасується
    const fetchUser = useUserStore(state => state.fetchUser)
    const hadPendingRefund = useRef(false)

    useEffect(() => {
        const hasPending = purchasesProducts.some((p) => p.refundStatus === 'pending')

        if (hasPending) {
            hadPendingRefund.current = true
            const timer = setTimeout(fetchPurchases, 5000)
            return () => clearTimeout(timer)
        }

        if (hadPendingRefund.current) {
            // повернення завершилось: підтягуємо оновлений баланс
            hadPendingRefund.current = false
            fetchUser()
        }
    }, [purchasesProducts])

    const empty = !purchasesProducts.length && !purchasesServices.length

    if (!loaded) {
        return (
            <div className="bk-page" aria-busy="true">
                <div>
                    <div className="bk-skeleton-title" />
                    <div className="bk-grid">
                        { Array.from({ length: 4 }, (_, i) =>
                            <div key={i} className="bk-skeleton">
                                <div className="bk-skeleton-media" />
                                <div className="bk-skeleton-line" />
                                <div className="bk-skeleton-line is-short" />
                            </div>
                        )}
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="bk-page">
            { !empty &&
                <div className="bk-howto">
                    <kbd className="bk-howto-key" aria-hidden="true">U</kbd>
                    <div className="bk-howto-text">
                        <b>Щоб забрати, натисніть U у грі</b>
                        <span>Зайдіть на сервер, вказаний на картці. Натисніть на картку, щоб повернути товар; предмети з ящика (значок «%») повертаються за 50%.</span>
                    </div>
                </div>
            }
            <ActivatedServices purchasesServices={purchasesServices} onRefresh={fetchPurchases} />
            <BasketItems purchasesProducts={purchasesProducts} setPurchasesProducts={setPurchasesProducts} onRefresh={fetchPurchases} />
            <NoItems purchasesProducts={purchasesProducts} purchasesServices={purchasesServices} />
        </div>
    );
};

export default Basket;
